import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  Pagination,
  OverlayTrigger,
  Tooltip,
  Table,
  Modal,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import {
  DeleteAppointment,
  resheduleAppointment,
  searchAppointment,
  GetDocAllUser,
  updateAptDoctor,
  getDocTimeSlots,
  getCallLogsById,
  GetAllDoctors,
  offlineCallStatusChange,
} from "../../../Listfunction";
import LoadingSpinner from "views/Components/loadingSpinner";
import Datetime from "react-datetime";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import { withRouter } from "react-router";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class viewAppointments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabledata: [],
      selectedappointment: "",
      cancelReason: "",
      cancelReasonError: null,
      apt_datetime: new Date(),
      apt_timeMsg: "",
      showCancelReason: false,
      selectedDoc: "",
      selectedDocId: "",
      assignDocErr: "",
      doc_list: [],
      userRole: "",
      _notificationSystem: null,
      alert: null,
      page: 1,
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      loading: false,
      noRecordFound: false,
      totpageNo: "",
      cardHidden: true,
      rescheduleAptShow: false,
      assignDocShow: false,
      consultation_no: "",
      doctor: "",
      patient: "",
      appointment_date: "",
      payment_status: "",
      apt_status: "",
      doc_timeSlots: [],
      selectedTimeSlot: "",
      showCallLogModal: false,
      callLogsData: [],
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.ConfirmAndCancelApt = this.ConfirmAndCancelApt.bind(this);
    this.searchData = this.searchData.bind(this);
    this.assignDoctor = this.assignDoctor.bind(this);
    this.rescheduleApt = this.rescheduleApt.bind(this);
    this.rescheduleAppointmentSubmit =
      this.rescheduleAppointmentSubmit.bind(this);
    this.rescheduleAppointmentClose =
      this.rescheduleAppointmentClose.bind(this);
    this.assignDocSubmit = this.assignDocSubmit.bind(this);
    this.assignDocClose = this.assignDocClose.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
  }

  yesterday = moment().subtract(1, "day");

  disablePastDt = (current) => {
    return current.isAfter(this.yesterday);
  };

  searchData = async (e) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var apt_date = "";

    if (
      this.state.appointment_date != "" &&
      this.state.appointment_date != null
    ) {
      apt_date = moment(this.state.appointment_date).format("YYYY-MM-DD");
      if (apt_date == "Invalid date") {
        apt_date = "";
      }
    }

    this.setState({ loading: true }, () =>
      searchAppointment(
        obj,
        this.state.page,
        this.state.consultation_no,
        apt_date,
        this.state.apt_status,
        this.state.doctor,
        this.state.patient,
        this.state.payment_status,
      )
        .then((response) => {
          if (response.success == true) {
            var data = response.data;

            console.log(data);

            if (data.data.length == 0) {
              this.setState({ noRecordFound: true });
            } else {
              this.setState({ noRecordFound: false });
            }

            var no_pages = [];
            let serach_string = "";
            for (var i = 1; i <= data.last_page; i++) {
              if (serach_string == "") {
                no_pages.push(i);
              } else {
                no_pages.push(i);
              }
            }

            if (data.current_page == data.last_page) {
              this.setState({ prevdisabled: null });
              this.setState({ nextdisabled: "1" });
            } else if (data.current_page == 1) {
              this.setState({ nextdisabled: null });
              this.setState({ prevdisabled: "1" });
            } else {
              this.setState({ nextdisabled: null });
              this.setState({ prevdisabled: null });
            }
            if (data.last_page == 1) {
              this.setState({ nextdisabled: 1 });
              this.setState({ prevdisabled: 1 });
            }
            if (data.length == 0) {
              no_pages = [];
              this.setState({ nextdisabled: 1 });
              this.setState({ prevdisabled: 1 });
            }
            this.setState({ currentPage: data.current_page });
            if (data.next_page_url != null) {
              if (serach_string == "") {
                this.setState({
                  nextpage: data.next_page_url.substring(
                    data.next_page_url.indexOf("?page=") + 1,
                  ),
                });
              } else {
                this.setState({
                  nextpage: data.next_page_url.substring(
                    data.next_page_url.indexOf("?page=") + 1,
                  ),
                });
              }
            } else {
              this.setState({ nextpage: "#" });
            }
            if (data.prev_page_url != null) {
              if (serach_string == "") {
                this.setState({
                  prevpage: data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1,
                  ),
                });
              } else {
                this.setState({
                  prevpage: data.prev_page_url.substring(
                    data.prev_page_url.indexOf("=") + 1,
                  ),
                });
              }
            } else {
              this.setState({ prevpage: "#" });
            }

            this.setState({
              paginationData: no_pages,
              loading: false,
              tabledata: response.data.data,
              totpageNo: data.last_page,
            });
          } else {
            alert("hi");
            this.handleClick("bl", "Something went wrong.");
          }
        })
        .catch(() => {
          this.handleClick("bl", "Something went wrong.");
        }),
    );
  };

  resetSearch() {
    this.setState({
      appointment_date: "",
      consultation_no: "",
      patient: "",
      doctor: "",
      apt_status: "",
      payment_status: "",
    });

    setTimeout(() => this.searchData(), 500);
  }

  ConfirmAndCancelApt() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (this.state.cancelReason == "" || this.state.cancelReason == null) {
      this.setState({
        cancelReasonError: (
          <small className="text-danger">
            Please enter appointment cancel reason
          </small>
        ),
      });
    } else {
      DeleteAppointment(
        obj,
        this.state.selectedappointment,
        this.state.cancelReason,
      )
        .then((res) => {
          console.log(res);
          if (res.data.success == true) {
            this.handleSuccess("bl", "Appointment Canceled successfully.");
            this.setState({
              cancelReason: "",
              cancelReasonError: null,
              showCancelReason: false,
            });
            this.searchData();
          } else {
            this.handleClick("bl", "Something went wrong");
          }
        })
        .catch((err) => {
          this.handleClick("bl", "Something went wrong");
        });
    }
  }

  rescheduleApt = (id, aptdate, name, doc_id) => {
    var today = new Date();
    var aptDate = new Date(aptdate);
    var newDateObj = "";
    if (today > aptDate) {
      var min = today.getMinutes();

      var inc = min % 10;

      if (inc < 5) {
        inc = 5 - inc;
      } else {
        inc = 10 - inc;
      }
      newDateObj = moment(today).add(inc, "m").toDate();
    } else {
      newDateObj = aptDate;
    }
    var secDate = moment(newDateObj).format("YYYY-MM-DD");
    this.getTimeslotDetails(doc_id, secDate);

    this.setState({
      apt_datetime: newDateObj,
      rescheduleAptShow: true,
      apt_timeMsg: "",
      selectedappointment: id,
      selectedDoc: name,
      selectedDocId: doc_id,
    });
  };

  onDoctorChange = (e) => {
    this.setState({
      selectedDoc: e.target.value,
      assignDocErr: null,
      selectedTimeSlot: "",
    });

    var secDate = moment(this.state.apt_datetime).format("YYYY-MM-DD");
    this.getTimeslotDetails(e.target.value, secDate);

    setTimeout(() => this.autoTimeSlotSelect(), 1000);
  };

  autoTimeSlotSelect = () => {
    var apt_time = moment(this.state.apt_datetime).format("HH:mm");
    apt_time = parseInt(apt_time.replace(":", ""));
    if (this.state.doc_timeSlots.length > 0) {
      for (let i = 0; i < this.state.doc_timeSlots.length; i++) {
        var details = this.state.doc_timeSlots[i].split(" - ");
        details[0] = parseInt(details[0].replace(":", ""));
        details[1] = parseInt(details[1].replace(":", ""));
        if (apt_time >= details[0] && apt_time < details[1]) {
          this.setState({
            selectedTimeSlot: this.state.doc_timeSlots[i],
          });
          break;
        }
      }
    }
  };

  getTimeslotDetails = (doc_id, secDate) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getDocTimeSlots(obj, doc_id, secDate)
      .then((res) => {
        var newTimeArr = [];
        if (res.success) {
          var docSch = res.data.doctor_schedule;
          if (docSch.length > 0) {
            for (let i = 0; i < docSch.length; i++) {
              var timeSlots = docSch[i].timeslots;
              for (let j = 0; j < timeSlots.length; j++) {
                if (timeSlots[j].is_disabled == false) {
                  var detail =
                    timeSlots[j].slot_start_time +
                    " - " +
                    timeSlots[j].slot_end_time;
                  newTimeArr.push(detail);
                }
              }
            }
          }
        }

        newTimeArr = newTimeArr.filter(this.uniquearr);

        this.setState({
          doc_timeSlots: newTimeArr,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  uniquearr = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  rescheduleAppointmentSubmit = () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var error = false;
    var mydate = this.state.apt_datetime;
    var re = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    if (mydate == null || mydate == "" || mydate == undefined) {
      error = true;
      this.setState({
        apt_timeMsg: (
          <small className="text-danger">
            Please select appointment date and time.
          </small>
        ),
      });
    } else if (mydate.length == undefined) {
      var support_date = moment(mydate).format("YYYY-MM-DD");
      if (re.test(support_date) == false) {
        error = true;
        this.setState({
          apt_timeMsg: (
            <small className="text-danger">Invalid date format.</small>
          ),
        });
      } else if (new Date(mydate) <= moment()) {
        error = true;
        this.setState({
          apt_timeMsg: (
            <small className="text-danger">
              Appointment date and time must be greater than current time.
            </small>
          ),
        });
      } else {
        this.setState({ apt_timeMsg: "" });
      }
    } else if (re.test(mydate) == false) {
      error = true;
      this.setState({
        apt_timeMsg: (
          <small className="text-danger">Invalid date format.</small>
        ),
      });
    } else {
      this.setState({ apt_timeMsg: "" });
    }

    if (!error) {
      if (this.state.selectedTimeSlot == "") {
        error = true;
        this.setState({
          apt_timeMsg: (
            <small className="text-danger">Please select timeslot</small>
          ),
        });
      }
    }

    if (!error) {
      var aptdate = moment(mydate).format("YYYY-MM-DD");

      var timeslot = this.state.selectedTimeSlot.split(" - ");
      aptdate = aptdate + " " + timeslot[0];

      resheduleAppointment(obj, this.state.selectedappointment, aptdate)
        .then((res) => {
          if (res.data.success == true) {
            this.handleSuccess("bl", "Appointment rescheduled successfully.");
            this.setState({
              apt_datetime: new Date(),
              rescheduleAptShow: false,
              apt_timeMsg: "",
              selectedDoc: "",
              selectedDocId: "",
              selectedTimeSlot: "",
              doc_timeSlots: [],
            });
            this.searchData();
          } else {
            this.handleClick("bl", "Something went wrong");
          }
        })
        .catch((err) => {
          this.handleClick("bl", "Something went wrong");
        });
    }
  };

  rescheduleAppointmentClose = () => {
    this.setState({
      apt_datetime: new Date(),
      rescheduleAptShow: false,
      apt_timeMsg: "",
      selectedTimeSlot: "",
      doc_timeSlots: [],
      selectedDocId: "",
      selectedDoc: "",
    });
  };

  assignDoctor = (id, aptdate) => {
    var today = new Date();
    var aptDate = new Date(aptdate);
    var newDateObj = "";
    if (today > aptDate) {
      var min = today.getMinutes();
      var inc = min % 10;

      if (inc < 5) {
        inc = 5 - inc;
      } else {
        inc = 10 - inc;
      }
      newDateObj = moment(today).add(inc, "m").toDate();
    } else {
      newDateObj = aptDate;
    }

    this.setState({
      apt_datetime: newDateObj,
      selectedDoc: "",
      assignDocShow: true,
      assignDocErr: null,
      selectedappointment: id,
    });
  };

  assignDocSubmit = () => {
    var error = false;
    var docError = null;
    var slotError = null;

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (this.state.selectedDoc == "" || this.state.selectedDoc == null) {
      error = true;
      docError = <small className="text-danger">Please select doctor</small>;
    }

    if (this.state.selectedTimeSlot == "") {
      error = true;
      slotError = <small className="text-danger">Please select slots</small>;
    }

    if (error) {
      this.setState({
        assignDocErr: docError,
        apt_timeMsg: slotError,
      });
    }

    if (!error) {
      var aptdate = moment(this.state.apt_datetime).format("YYYY-MM-DD");
      var timeslot = this.state.selectedTimeSlot.split(" - ");
      aptdate = aptdate + " " + timeslot[0];

      updateAptDoctor(
        obj,
        this.state.selectedappointment,
        this.state.selectedDoc,
        aptdate,
      )
        .then((res) => {
          console.log(res);
          if (res.data.success == true) {
            this.handleSuccess("bl", "Doctor assigned successfully.");
            this.setState({
              selectedDoc: "",
              assignDocShow: false,
              assignDocErr: "",
              apt_timeMsg: "",
              selectedTimeSlot: "",
              doc_timeSlots: [],
              selectedDocId: "",
            });
            this.searchData();
          } else {
            this.handleClick("bl", "Something went wrong");
          }
        })
        .catch((err) => {
          this.handleClick("bl", "Something went wrong");
        });
    }
  };

  assignDocClose = () => {
    this.setState({
      selectedDoc: "",
      assignDocShow: false,
      assignDocErr: "",
      selectedTimeSlot: "",
      doc_timeSlots: [],
      selectedDocId: "",
    });
  };

  handleDateChange = (date) => {
    var mydate = moment(date).format("YYYY-MM-DD");
    var re = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    if (mydate == null || mydate == "" || mydate == undefined) {
      this.setState({
        apt_timeMsg: (
          <small className="text-danger">
            Please select appointment date and time.
          </small>
        ),
      });
    } else if (mydate.length == undefined) {
      var support_date = moment(mydate).format("YYYY-MM-DD");
      if (re.test(support_date) == false) {
        this.setState({
          apt_timeMsg: (
            <small className="text-danger">Invalid date format.</small>
          ),
        });
      } else if (new Date(date) <= moment()) {
        this.setState({
          apt_timeMsg: (
            <small className="text-danger">
              Appointment date and time must be greater than current time.
            </small>
          ),
        });
      } else {
        this.setState({ apt_timeMsg: "" });

        var secDate = moment(date).format("YYYY-MM-DD");
        this.getTimeslotDetails(this.state.selectedDocId, secDate);
      }
    } else if (re.test(mydate) == false) {
      this.setState({
        apt_timeMsg: (
          <small className="text-danger">Invalid date format.</small>
        ),
      });
    } else {
      this.setState({ apt_timeMsg: "" });

      var secDate = moment(date).format("YYYY-MM-DD");
      this.getTimeslotDetails(this.state.selectedDocId, secDate);
    }

    this.setState({ apt_datetime: date });
  };

  cancelAppointment(id) {
    this.setState({
      cancelReason: "",
      showCancelReason: true,
      cancelReasonError: null,
      selectedappointment: id,
    });
  }

  closeCancelModal = () => {
    this.setState({
      cancelReason: "",
      cancelReasonError: null,
      showCancelReason: false,
    });
  };

  paginationinfo(url, id) {
    this.setState({
      page: url,
    });
    this.searchData();
  }

  handleSuccess(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 3,
    });
  }

  handleClick(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{message}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await GetAllDoctors(obj)
      .then((res) => {
        const doctorList = res.data.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
        this.setState({ doc_list: doctorList });
      })
      .catch((err) => {
        console.log(err);
      });

    this.setState({
      userRole: token.role,
      _notificationSystem: this.refs.notificationSystem,
    });

    this.searchData();

    setTimeout(
      function () {
        this.setState({
          cardHidden: false,
        });
      }.bind(this),
      700,
    );
  }

  capitalizeFirstLetter = (string) => {
    if (string != "" && string != null && string != undefined) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return "";
    }
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  setTimeSlot = (id) => {
    this.setState({
      selectedTimeSlot: this.state.doc_timeSlots[id],
      apt_timeMsg: "",
    });
  };

  openCallLoigModal(ConsultationId) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ showCallLogModal: true });

    getCallLogsById(obj, ConsultationId)
      .then((res) => {
        this.setState({ callLogsData: res.data.payload });
      })
      .catch((error) => {
        this.handleNetworkError("bl", error.message);
      });
  }

  copyTheDeviceInfoDetails(deviceInfo) {
    const textFile = JSON.stringify(deviceInfo);
    navigator.clipboard.writeText(textFile);
    this.handleSuccess("tr", "Object Coppied.");
  }

  HandleChangeOffLineStatusConfirmation = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.changeStatusAsOffline(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, Change it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You Want To Change This Status As Offline!
        </SweetAlert>
      ),
    });
  };
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  changeStatusAsOffline = (id) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let status = 6;
    offlineCallStatusChange(obj, id, status)
      .then((res) => {
        if (res.data.success == true) {
          this.handleSuccess("bl", "Appointment status changed successfully.");
          this.hideAlert();
          this.searchData();
        } else {
          this.handleClick("bl", "Something went wrong");
        }
      })
      .catch((err) => {
        this.handleClick("bl", "Something went wrong");
      });
  };

  render() {
    const remove = <Tooltip id="remove">Cancel Appointment</Tooltip>;
    const reschapy = <Tooltip id="remove">Reschedule Appointment</Tooltip>;
    const assigndoc = <Tooltip id="remove">Assign Doctor</Tooltip>;
    const callLog = <Tooltip id="remove">Call Log</Tooltip>;
    const OfflineCall = <Tooltip id="remove">Off Line Call</Tooltip>;

    let c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Card
                content={
                  <React.Fragment>
                    <Row>
                      <Col
                        xs={12}
                        className="OrderList_fill"
                        style={{
                          borderRadius: "5px",
                          paddingTop: "10px",
                          // paddingBottom: "10px",
                          width: "100%",
                          // marginLeft: "12px",
                        }}
                      >
                        <Col md={3} sm={6} xs={12}>
                          <FormControl
                            name="consultation_no"
                            value={this.state.consultation_no || ""}
                            placeholder="Consultation No"
                            onChange={this.onChange}
                            type="text"
                            className="forminoput_nomargin"
                          />
                        </Col>

                        <Col md={3} sm={6} xs={12}>
                          <FormControl
                            name="doctor"
                            value={this.state.doctor || ""}
                            placeholder="Doctor"
                            onChange={this.onChange}
                            type="text"
                            className="forminoput_nomargin"
                          />
                        </Col>

                        <Col md={3} sm={6} xs={12}>
                          <FormControl
                            name="patient"
                            value={this.state.patient || ""}
                            placeholder="Patient"
                            onChange={this.onChange}
                            type="text"
                            className="forminoput_nomargin"
                          />
                        </Col>

                        <Col md={3} sm={6} xs={12}>
                          <Datetime
                            className="filter_FormTodate forminoput_nomargin"
                            timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: "Select Date" }}
                            closeOnSelect={true}
                            value={this.state.appointment_date}
                            onChange={(date) => {
                              this.setState({ appointment_date: date });
                            }}
                          />
                        </Col>

                        <Col md={3} sm={6} xs={12}>
                          <select
                            name="apt_status"
                            onChange={this.onChange}
                            value={this.state.apt_status}
                            className="form-control forminoput_nomargin"
                          >
                            <option value="">Status</option>
                            <option value="1">Scheduled</option>
                            <option value="2">Completed</option>
                            <option value="3">Cancelled</option>
                            <option value="4">Rescheduled</option>
                            <option value="5">Missed</option>
                          </select>
                        </Col>

                        <Col md={3} sm={6} xs={12}>
                          <select
                            name="payment_status"
                            onChange={this.onChange}
                            value={this.state.payment_status}
                            className="form-control forminoput_nomargin"
                          >
                            <option value="">Payment Status</option>
                            <option value="success">Success</option>
                            <option value="failed">Failed</option>
                          </select>
                        </Col>

                        <Col md={5} xs={12} className="appointment_btns">
                          <Button
                            bsStyle="info"
                            fill
                            onClick={this.searchData.bind(this)}
                          >
                            Search
                          </Button>
                          &nbsp;&nbsp;
                          <div className="btn_reset_appointment">
                            <Button
                              class="btn-color"
                              fill
                              onClick={this.resetSearch.bind(this)}
                            >
                              Reset
                            </Button>
                          </div>
                        </Col>
                      </Col>
                      <Col>
                        <div className="desktop-table">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>Consultation ID</th>
                                <th>Doctor</th>
                                <th>Patient</th>
                                <th>Patient Mobile</th>
                                <th>Appointment Time</th>
                                <th>Call Type</th>
                                <th>Payment Status</th>
                                <th>Status</th>
                                {/* <th></th> */}
                                <th style={{ textAlign: "end" }}>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loading ? (
                                <tr>
                                  <td colspan="10">
                                    <LoadingSpinner />
                                  </td>
                                </tr>
                              ) : this.state.noRecordFound ? (
                                <tr>
                                  <td colspan="10">
                                    <center>No record found</center>
                                  </td>
                                </tr>
                              ) : (
                                <React.Fragment>
                                  {this.state.tabledata.map((cus, i) => (
                                    <tr key={i}>
                                      <td
                                        key={cus.id}
                                        style={{ textTransform: "capitalize" }}
                                      >
                                        {JSON.parse(cus.fa_data)
                                          ? JSON.parse(cus.fa_data)
                                              .consultationId
                                          : ""}
                                      </td>
                                      <td
                                        key={cus.id}
                                        style={{ textTransform: "capitalize" }}
                                      >
                                        {cus.doctor ? cus.doctor.name : ""}
                                      </td>
                                      <td>
                                        {cus.patient ? cus.patient.name : ""}
                                      </td>
                                      <td>
                                        {cus.patient
                                          ? cus.patient.mobile_no
                                          : ""}
                                      </td>
                                      <td>{cus.appointment_date}</td>
                                      <td>
                                        {JSON.parse(cus.fa_data)
                                          ? JSON.parse(cus.fa_data).callType
                                          : "-"}
                                        {cus.is_claimable == "1" ? (
                                          <i
                                            style={{
                                              fontSize: "14px",
                                              background: "red",
                                              color: "white",
                                              borderRadius: "5px",
                                              margin: "5px",
                                              paddingLeft: "5px",
                                              paddingRight: "5px",
                                            }}
                                          >
                                            {" "}
                                            Claim
                                          </i>
                                        ) : null}
                                      </td>
                                      <td>
                                        {this.capitalizeFirstLetter(
                                          cus.payment_status,
                                        )}
                                      </td>
                                      <td>
                                        {cus.status == 1
                                          ? "Scheduled"
                                          : cus.status == 2
                                            ? "Completed"
                                            : cus.status == 3
                                              ? "Cancelled"
                                              : cus.status == 4
                                                ? "Rescheduled"
                                                : cus.status == 5
                                                  ? "Missed"
                                                  : cus.status == 6
                                                    ? "Offline"
                                                    : "-"}
                                      </td>

                                      <td
                                        className="td-actions"
                                        style={{ textAlign: "end" }}
                                      >
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={callLog}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={() =>
                                              this.openCallLoigModal(
                                                JSON.parse(cus.fa_data)
                                                  ? JSON.parse(cus.fa_data)
                                                      .consultationId
                                                  : "",
                                              )
                                            }
                                            bsSize="xs"
                                          >
                                            <i
                                              class="fa fa-book"
                                              aria-hidden="true"
                                            ></i>
                                          </Button>
                                        </OverlayTrigger>
                                        {cus.status != 3 && cus.status != 2 ? (
                                          <>
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={assigndoc}
                                            >
                                              <Button
                                                simple
                                                bsStyle="success"
                                                onClick={this.assignDoctor.bind(
                                                  this,
                                                  cus.id,
                                                  cus.appointment_date,
                                                )}
                                                bsSize="xs"
                                              >
                                                <i
                                                  class="fa fa-tasks"
                                                  aria-hidden="true"
                                                ></i>
                                              </Button>
                                            </OverlayTrigger>

                                            <OverlayTrigger
                                              placement="top"
                                              overlay={OfflineCall}
                                            >
                                              <Button
                                                simple
                                                bsStyle="success"
                                                onClick={() =>
                                                  this.HandleChangeOffLineStatusConfirmation(
                                                    cus.id,
                                                  )
                                                }
                                                bsSize="xs"
                                              >
                                                <i
                                                  class="fas fa-phone-slash"
                                                  aria-hidden="true"
                                                ></i>
                                              </Button>
                                            </OverlayTrigger>

                                            <OverlayTrigger
                                              placement="top"
                                              overlay={reschapy}
                                            >
                                              <Button
                                                simple
                                                bsStyle="success"
                                                onClick={this.rescheduleApt.bind(
                                                  this,
                                                  cus.id,
                                                  cus.appointment_date,
                                                  cus.doctor
                                                    ? cus.doctor.name
                                                    : "",
                                                  cus.doctor
                                                    ? cus.doctor.id
                                                    : "",
                                                )}
                                                bsSize="xs"
                                              >
                                                <i
                                                  class="fa fa-calendar"
                                                  aria-hidden="true"
                                                ></i>
                                              </Button>
                                            </OverlayTrigger>

                                            <OverlayTrigger
                                              placement="top"
                                              overlay={remove}
                                            >
                                              <Button
                                                simple
                                                bsStyle="danger"
                                                onClick={this.cancelAppointment.bind(
                                                  this,
                                                  cus.id,
                                                )}
                                                bsSize="xs"
                                              >
                                                <i className="fa fa-times" />
                                              </Button>
                                            </OverlayTrigger>
                                          </>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )}
                            </tbody>
                          </Table>
                        </div>
                        {/* card vew */}
                        <div className="card-container">
                          {this.state.loading ? (
                            <div className="loading-spinner">
                              <LoadingSpinner />
                            </div>
                          ) : this.state.noRecordFound ? (
                            <div className="no-record-found">
                              <center>No record found</center>
                            </div>
                          ) : (
                            this.state.tabledata.map((cus, i) => (
                              <div key={i} className="card">
                                <div className="card-header">
                                  <div>
                                    <strong>CONSULTATION ID : </strong>&nbsp;
                                    {JSON.parse(cus.fa_data)
                                      ? JSON.parse(cus.fa_data).consultationId
                                      : ""}
                                  </div>
                                </div>
                                <div className="card-content">
                                  <div
                                    key={cus.id}
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    <strong>DOCTOR :</strong>&nbsp;
                                    {cus.doctor ? cus.doctor.name : ""}
                                  </div>
                                  <div>
                                    <strong>PATIENT : </strong>&nbsp;
                                    {cus.patient ? cus.patient.name : ""}
                                  </div>
                                  <div>
                                    <strong>PATIENT MOBILE : </strong>&nbsp;
                                    {cus.patient ? cus.patient.mobile_no : ""}
                                  </div>
                                  <div>
                                    <strong>APPOINTMENT TIME : </strong>&nbsp;
                                    {cus.appointment_date}
                                  </div>
                                  <div>
                                    <strong>CALL TYPE : </strong>&nbsp;
                                    {JSON.parse(cus.fa_data)
                                      ? JSON.parse(cus.fa_data).callType
                                      : "-"}
                                    {cus.is_claimable == "1" ? (
                                      <i
                                        style={{
                                          fontSize: "14px",
                                          background: "red",
                                          color: "white",
                                          borderRadius: "5px",
                                          margin: "5px",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                        }}
                                      >
                                        {" "}
                                        Claim
                                      </i>
                                    ) : null}
                                  </div>
                                  <div>
                                    <strong>PAYMENT STATUS :</strong>&nbsp;
                                    {this.capitalizeFirstLetter(
                                      cus.payment_status,
                                    )}
                                  </div>
                                  <div>
                                    <strong>STATUS : </strong>&nbsp;
                                    {cus.status == 1
                                      ? "Scheduled"
                                      : cus.status == 2
                                        ? "Completed"
                                        : cus.status == 3
                                          ? "Cancelled"
                                          : cus.status == 4
                                            ? "Rescheduled"
                                            : cus.status == 5
                                              ? "Missed"
                                              : cus.status == 6
                                                ? "Offline"
                                                : "-"}
                                  </div>
                                  <div>
                                    <strong>ACTION :</strong>&nbsp;
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={callLog}
                                    >
                                      <Button
                                        simple
                                        bsStyle="success"
                                        onClick={() =>
                                          this.openCallLoigModal(
                                            JSON.parse(cus.fa_data)
                                              ? JSON.parse(cus.fa_data)
                                                  .consultationId
                                              : "",
                                          )
                                        }
                                        bsSize="xs"
                                      >
                                        <i
                                          class="fa fa-book"
                                          aria-hidden="true"
                                        ></i>
                                      </Button>
                                    </OverlayTrigger>
                                    {cus.status != 3 && cus.status != 2 ? (
                                      <>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={assigndoc}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={this.assignDoctor.bind(
                                              this,
                                              cus.id,
                                              cus.appointment_date,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i
                                              class="fa fa-tasks"
                                              aria-hidden="true"
                                            ></i>
                                          </Button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                          placement="top"
                                          overlay={OfflineCall}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={() =>
                                              this.HandleChangeOffLineStatusConfirmation(
                                                cus.id,
                                              )
                                            }
                                            bsSize="xs"
                                          >
                                            <i
                                              class="fas fa-phone-slash"
                                              aria-hidden="true"
                                            ></i>
                                          </Button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                          placement="top"
                                          overlay={reschapy}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            onClick={this.rescheduleApt.bind(
                                              this,
                                              cus.id,
                                              cus.appointment_date,
                                              cus.doctor ? cus.doctor.name : "",
                                              cus.doctor ? cus.doctor.id : "",
                                            )}
                                            bsSize="xs"
                                          >
                                            <i
                                              class="fa fa-calendar"
                                              aria-hidden="true"
                                            ></i>
                                          </Button>
                                        </OverlayTrigger>

                                        <OverlayTrigger
                                          placement="top"
                                          overlay={remove}
                                        >
                                          <Button
                                            simple
                                            bsStyle="danger"
                                            onClick={this.cancelAppointment.bind(
                                              this,
                                              cus.id,
                                            )}
                                            bsSize="xs"
                                          >
                                            <i className="fa fa-times" />
                                          </Button>
                                        </OverlayTrigger>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))
                          )}
                        </div>

                        {this.state.loading
                          ? ""
                          : this.state.noRecordFound
                            ? ""
                            : this.state.totpageNo > 1 && (
                                <div style={{ textAlign: "center" }}>
                                  <Pagination>
                                    {!this.state.prevdisabled ? (
                                      <Pagination.First
                                        onClick={this.paginationinfo.bind(
                                          this,
                                          this.state.prevpage,
                                        )}
                                        disabled={this.state.prevdisabled}
                                      />
                                    ) : (
                                      ""
                                    )}
                                    {this.state.paginationData.map((url) => (
                                      <Pagination.Item
                                        active={
                                          this.state.currentPage == c
                                            ? "1"
                                            : null
                                        }
                                        onClick={this.paginationinfo.bind(
                                          this,
                                          url,
                                        )}
                                      >
                                        {c++}
                                      </Pagination.Item>
                                    ))}
                                    {!this.state.nextdisabled ? (
                                      <Pagination.Last
                                        onClick={this.paginationinfo.bind(
                                          this,
                                          this.state.nextpage,
                                        )}
                                        disabled={this.state.nextdisabled}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </Pagination>
                                </div>
                              )}
                      </Col>
                    </Row>
                  </React.Fragment>
                }
              />
            </Col>
          </Row>
        </Grid>

        <Modal
          show={this.state.showCancelReason}
          onHide={() => this.setState({ showCancelReason: false })}
        >
          <Modal.Header>
            <Modal.Title className="text-center">
              Cancel Appointment
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Cancel Reason</ControlLabel>
              <textarea
                name="cancelReason"
                value={this.state.cancelReason}
                onChange={(event) => {
                  this.setState({
                    cancelReason: event.target.value,
                    cancelReasonError: "",
                  });
                }}
                className="form-control"
                rows={5}
                style={{ resize: "none" }}
              ></textarea>
              {this.state.cancelReasonError}
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.ConfirmAndCancelApt.bind(this)}
              bsStyle="success"
              fill
            >
              Submit
            </Button>
            &nbsp;
            <Button
              onClick={this.closeCancelModal.bind(this)}
              bsStyle="info"
              fill
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.rescheduleAptShow}
          onHide={() => this.setState({ rescheduleAptShow: false })}
        >
          <Modal.Header>
            <Modal.Title className="text-center">
              Reschedule Appointment
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Doctor</ControlLabel>
              <select
                disabled
                className="react-select info form-control"
                placeholder="Select Doctor"
                name="selectedDoc"
                value={this.state.selectedDoc}
              >
                <option value={this.state.selectedDoc}>
                  {this.state.selectedDoc}
                </option>
              </select>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Date</ControlLabel>
              <div className="api_dateandtime">
                <Datetime
                  format="y-MM-dd h:mm:ss"
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Appointment Date" }}
                  defaultValue={this.state.apt_datetime}
                  closeOnSelect={true}
                  name="apt_datetime"
                  value={this.state.apt_datetime}
                  onChange={this.handleDateChange}
                  isValidDate={this.disablePastDt}
                />
              </div>
            </FormGroup>
            {this.state.doc_timeSlots.length > 0 && (
              <FormGroup>
                <ControlLabel style={{ width: "100%" }}>
                  Time Slots
                </ControlLabel>
                {this.state.doc_timeSlots.map((dts, idx) => (
                  <Button
                    className={
                      this.state.selectedTimeSlot == dts
                        ? "selectedButtonClass"
                        : "disabledTimeSlot"
                    }
                    onClick={() => this.setTimeSlot(idx)}
                  >
                    {dts}
                  </Button>
                ))}
              </FormGroup>
            )}
            {this.state.apt_timeMsg}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.rescheduleAppointmentSubmit.bind(this)}
              bsStyle="success"
              fill
            >
              Submit
            </Button>
            &nbsp;
            <Button
              onClick={this.rescheduleAppointmentClose.bind(this)}
              bsStyle="info"
              fill
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.assignDocShow}
          onHide={() => this.setState({ assignDocShow: false })}
        >
          <Modal.Header>
            <Modal.Title className="text-center">Assign Doctor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Doctor</ControlLabel>
              <select
                className="react-select info form-control"
                placeholder="Select Doctor"
                name="selectedDoc"
                value={this.state.selectedDoc}
                onChange={(e) => this.onDoctorChange(e)}
              >
                <option value="">Select Doctor</option>
                {this.state.doc_list.map((doc, idd) => (
                  <option key={idd} value={doc.value}>
                    {doc.label}
                  </option>
                ))}
              </select>
              {this.state.assignDocErr}
            </FormGroup>
            <FormGroup>
              <ControlLabel style={{ width: "100%" }}>Date</ControlLabel>
              {moment(this.state.apt_datetime).format("DD/MM/YYYY")}
              {/*<div className="api_dateandtime">
                <Datetime
                  format="y-MM-dd h:mm:ss"
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Appointment Date" }}
                  defaultValue={this.state.apt_datetime}
                  closeOnSelect={true}
                  name="apt_datetime"
                  value={this.state.apt_datetime}
                />
                </div>*/}
            </FormGroup>
            {this.state.doc_timeSlots.length > 0 && (
              <FormGroup>
                <ControlLabel style={{ width: "100%" }}>
                  Time Slots
                </ControlLabel>
                {this.state.doc_timeSlots.map((dts, idx) => (
                  <Button
                    className={
                      this.state.selectedTimeSlot == dts
                        ? "selectedButtonClass"
                        : "disabledTimeSlot"
                    }
                    onClick={() => this.setTimeSlot(idx)}
                  >
                    {dts}
                  </Button>
                ))}
              </FormGroup>
            )}
            {this.state.apt_timeMsg}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.assignDocSubmit.bind(this)}
              bsStyle="success"
              fill
            >
              Submit
            </Button>
            &nbsp;
            <Button
              onClick={this.assignDocClose.bind(this)}
              bsStyle="info"
              fill
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={this.state.showCallLogModal}
          onHide={() => this.setState({ showCallLogModal: false })}
          bsSize="lg"
        >
          <Modal.Header>
            <Modal.Title>Call Logs</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ overflowY: "scroll", height: "70vh" }}>
            <Table>
              <thead xs={12} sm={12} md={12} lg={12}>
                <th>Action</th>
                <th>Description</th>
                <th>Application</th>
                <th style={{ padding: "10px" }}>DeviceInfo</th>
                <th>Date</th>
                <th>User</th>
                <th>Consultation</th>
              </thead>
              <tbody>
                {this.state.callLogsData.length === 0 ? (
                  <tr>
                    <td colSpan="10">
                      <center>No data found....</center>
                    </td>
                  </tr>
                ) : (
                  this.state.callLogsData &&
                  this.state.callLogsData.map((data) => (
                    <tr>
                      <td>{data.action === null ? "" : data.action}</td>
                      <td>
                        {data.description === null ? "" : data.description}
                      </td>
                      <td>
                        {data.application === null ? "" : data.application}
                      </td>
                      <td>
                        {data.deviceInfo !== null || undefined || "" ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="deviceInfo">
                                {
                                  <>
                                    <p>
                                      Device type:{" "}
                                      {data.deviceInfo.deviceType !== null || ""
                                        ? data.deviceInfo.deviceType
                                        : ""}
                                    </p>
                                    <p>
                                      Room socket connected:{" "}
                                      {data.deviceInfo.isRoomSocketConnected ===
                                      true
                                        ? "yes"
                                        : "No"}
                                    </p>
                                    <p>
                                      Socket connected:{" "}
                                      {data.deviceInfo.isSocketConnected ===
                                      true
                                        ? "yes"
                                        : "No"}
                                    </p>
                                    <p>
                                      Network type:{" "}
                                      {data.deviceInfo.deviceType !== null || ""
                                        ? data.deviceInfo.deviceType
                                        : ""}
                                    </p>
                                    <p>
                                      OS version:{" "}
                                      {data.deviceInfo.osVersion !== null || ""
                                        ? data.deviceInfo.osVersion
                                        : ""}
                                    </p>
                                  </>
                                }
                              </Tooltip>
                            }
                          >
                            <Button
                              onClick={() =>
                                this.copyTheDeviceInfoDetails(data.deviceInfo)
                              }
                            >
                              Copy
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        {data.dateAndTime === null
                          ? ""
                          : moment(data.dateAndTime).format(
                              "YYYY-MM-DD hh:mm:ss",
                            )}
                      </td>
                      <td>
                        {data.user !== null || undefined || "" ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="user">
                                {
                                  <>
                                    <p>
                                      Name:{" "}
                                      {data.user.name !== null || ""
                                        ? data.user.name
                                        : ""}
                                    </p>
                                    <p>
                                      Email:{" "}
                                      {data.user.email !== null || ""
                                        ? data.user.email
                                        : ""}
                                    </p>
                                    <p>
                                      Mobile No:{" "}
                                      {data.user.phoneNumber !== null || ""
                                        ? data.user.phoneNumber
                                        : ""}
                                    </p>
                                    <p>
                                      Admin user Id:{" "}
                                      {data.user.adminUserId !== null || ""
                                        ? data.user.adminUserId
                                        : ""}
                                    </p>
                                    <p>
                                      User Type:{" "}
                                      {data.user.userType !== null || ""
                                        ? data.user.userType
                                        : ""}
                                    </p>
                                  </>
                                }
                              </Tooltip>
                            }
                          >
                            <Button
                              style={{
                                border: "none",
                                margin: "0px",
                                padding: "0px",
                              }}
                              onClick={() =>
                                this.copyTheDeviceInfoDetails(data.user)
                              }
                            >
                              {data.user.name}
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        {data.consultation !== null || undefined || "" ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="consultation">
                                {
                                  <>
                                    <p>
                                      Consultation Id:{" "}
                                      {data.consultation.consultationId !==
                                        null || ""
                                        ? data.consultation.consultationId
                                        : ""}
                                    </p>
                                    <p>
                                      Flash Consultation Id:{" "}
                                      {data.consultation.flashConsultationId !==
                                        null || ""
                                        ? data.consultation.flashConsultationId
                                        : ""}
                                    </p>
                                    <p>
                                      Call Type:{" "}
                                      {data.consultation.callType !== null || ""
                                        ? data.consultation.callType
                                        : ""}
                                    </p>
                                    <p>
                                      Doctor Name:{" "}
                                      {data.consultation.doctorName !== null ||
                                      ""
                                        ? data.consultation.doctorName
                                        : ""}
                                    </p>
                                    <p>
                                      Patient Name:{" "}
                                      {data.consultation.patientName !== null ||
                                      ""
                                        ? data.consultation.patientName
                                        : ""}
                                    </p>
                                  </>
                                }
                              </Tooltip>
                            }
                          >
                            <Button
                              onClick={() =>
                                this.copyTheDeviceInfoDetails(data.consultation)
                              }
                            >
                              Consultation Details
                            </Button>
                          </OverlayTrigger>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} md={12} xs={12} className="text-right">
              <Button
                bsStyle="danger"
                fill
                onClick={() => this.setState({ showCallLogModal: false })}
              >
                Cancel
              </Button>
            </Col>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default withRouter(viewAppointments);
